import { Box, Typography } from '@mui/material';

/**
 * Consistent page title row — actions always top-right.
 */
export default function PageHeader({ title, subtitle, actions, sx }) {
  return (
    <Box
      sx={{
        mb: 2.5,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        gap: 2,
        ...sx
      }}
    >
      <Box sx={{ minWidth: 0, flex: '1 1 220px' }}>
        <Typography variant="h5" component="h1" sx={{ mb: subtitle ? 0.5 : 0 }}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {actions ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            flexWrap: 'wrap',
            flexShrink: 0
          }}
        >
          {actions}
        </Box>
      ) : null}
    </Box>
  );
}
